import React from "react";
import { useNavigate } from "react-router-dom";
import BusinessLocationSelection from "./BusinessLocationSelection";
import { useGMBConnection } from "../hooks/useGMBConnection";

const GMBCallback: React.FC = () => {
  const navigate = useNavigate();
  const {
    loading,
    error,
    refreshToken,
    email,
    locations,
    customers,
  } = useGMBConnection();

  const goToConnect = () => navigate("/social-posts?tab=connect");

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen p-4">
        <div className="w-full flex justify-start pl-4 mb-2">
          <button
            type="button"
            onClick={goToConnect}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back
          </button>
        </div>
        <div className="flex flex-col items-center justify-center flex-1">
          <div className="text-center">
            <div className="w-12 h-12 border-4 border-gray-200 border-t-brand-primary rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Connecting to Google My Business...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col min-h-screen p-4">
        <div className="w-full flex justify-start pl-4 mb-2">
          <button
            type="button"
            onClick={goToConnect}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back
          </button>
        </div>
        <div className="flex flex-col items-center justify-center flex-1">
          <div className="w-full max-w-4xl bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8">
            <p className="text-red-600 mb-4">{error}</p>
            <button
              type="button"
              onClick={goToConnect}
              className="px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-hover"
            >
              Back to Connect
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen p-4">
      <div className="w-full flex justify-start pl-4 mb-2">
        <button
          type="button"
          onClick={goToConnect}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back
        </button>
      </div>
      <div className="flex flex-col items-center w-full flex-1">
        <div className="w-full max-w-4xl bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8">
          <BusinessLocationSelection
            locations={locations}
            refreshToken={refreshToken}
            email={email}
            customers={customers}
            onClose={goToConnect}
          />
        </div>
      </div>
    </div>
  );
};

export default GMBCallback;
